import React, { useState } from "react";
import { useProductsSelectionStore } from "../../stores/productsSelectionStore";
import { useProductsStore } from "../../stores/productsStore";
import { useConfirmationStore } from "components";
import { UPDATE_STATUS_OPTIONS } from "../../utils/productsConfig";

// Компонент для відображення кнопок управління масовими змінами
const ProductsBulkActions = ({ currentSkusOnPage, isEmpty }) => {
  // Отримуємо дані та дії зі стору
  const isSelectionModeActive = useProductsSelectionStore(
    (state) => state.isSelectionModeActive,
  );
  const selectedSkus = useProductsSelectionStore((state) => state.selectedSkus);
  const toggleSelectionMode = useProductsSelectionStore(
    (state) => state.toggleSelectionMode,
  );
  const selectAll = useProductsSelectionStore((state) => state.selectAll);
  const updateStatusForSelected = useProductsSelectionStore(
    (state) => state.updateStatusForSelected,
  );
  const isLoading = useProductsSelectionStore((state) => state.isLoading);

  // Отримуємо дію зі стору продуктів постачальників (для оновлення таблиці)
  const fetchProducts = useProductsStore((state) => state.fetchProducts);
  // Отримуємо хук для відображення підтвердження
  const showConfirmation = useConfirmationStore((state) => state.showConfirmation);

  const [selectedStatus, setSelectedStatus] = useState(UPDATE_STATUS_OPTIONS[0].value);

  // Обробник оновлення
  const handleUpdate = () => {
    if (selectedSkus.length === 0) return;

    showConfirmation({
      title: "Масова зміна налаштувань",
      message: `Ви впевнені, що хочете встановити статус "${selectedStatus}" для ${selectedSkus.length} товарів?`,
      onConfirm: async () => {
        await updateStatusForSelected(selectedStatus);
        fetchProducts();
      },
    });
  };

  // Режим вибору неактивний, показуємо кнопку включення
  if (!isSelectionModeActive) {
    return (
      <button
        className="focus-button"
        onClick={toggleSelectionMode}
        title="Увімкнути масове редагування"
        disabled={isEmpty}
      >
        Редагувати
      </button>
    );
  }

  return (
    <div className="bulk-bar">
      {/* Інфо про кількість */}
      <span className="bulk-bar__info">Обрано: {selectedSkus.length}</span>

      {/* Кнопка "Обрати всі" */}
      <button className="bulk-bar__link" onClick={() => selectAll(currentSkusOnPage)}>
        Обрати Всі
      </button>

      {/* Вибір статусу */}
      <select
        className="form-select"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
        disabled={isLoading}
      >
        {UPDATE_STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {/* Кнопка дії */}
      <button
        className="focus-button"
        onClick={handleUpdate}
        disabled={isLoading || selectedSkus.length === 0}
      >
        {isLoading ? "Завантаження" : "Застосувати"}
      </button>

      {/* Кнопка скасування */}
      <button
        className="focus-button-secondary"
        onClick={toggleSelectionMode}
        disabled={isLoading}
      >
        Скасувати
      </button>
    </div>
  );
};

export default ProductsBulkActions;
